__turbopack_context__.v({
  "blocksBackgroundColor": "Filters-module-scss-module__gIJHpG__blocksBackgroundColor",
  "blocksFontColor": "Filters-module-scss-module__gIJHpG__blocksFontColor",
  "filterContainer": "Filters-module-scss-module__gIJHpG__filterContainer",
  "filterContainerWrapper": "Filters-module-scss-module__gIJHpG__filterContainerWrapper",
  "searchBox": "Filters-module-scss-module__gIJHpG__searchBox",
  "searchContainer": "Filters-module-scss-module__gIJHpG__searchContainer",
  "secondaryNavBackgroundColor": "Filters-module-scss-module__gIJHpG__secondaryNavBackgroundColor",
  "themeBackgroundColor": "Filters-module-scss-module__gIJHpG__themeBackgroundColor",
  "themeFontColor": "Filters-module-scss-module__gIJHpG__themeFontColor",
  "themeFontFamily": "Filters-module-scss-module__gIJHpG__themeFontFamily",
});
